// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/equipmentRounding.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9489: ONE equipment half-hour rounding decision — server enrichment,
// clock.js and billing.js.)
//
// Side-effect module: attaches `window.EquipmentRounding`. clock.js and
// billing.js read it at CALL time.
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  /** Tenant settings key for the company default. Absent = off. */
  const EQUIPMENT_ROUND_SETTING_KEY = 'roundEquipmentHalfHour';

  /** The company default from a tenant `settings` map. Only an explicit true is on. */
  function companyRoundsEquipment(settings) {
    return !!settings && typeof settings === 'object' && settings[EQUIPMENT_ROUND_SETTING_KEY] === true;
  }

  /** A stored price-book value -> 'always' | 'never' | 'default'. */
  function equipmentRoundChoice(v) {
    if (v === true) return 'always';
    if (v === false) return 'never';
    return 'default';
  }

  /** 'always' | 'never' | anything else -> the value to store (true | false | null). */
  function equipmentRoundStored(choice) {
    if (choice === 'always') return true;
    if (choice === 'never') return false;
    return null;
  }

  /** Is this a per-line override (Always / Never), not Company default? */
  function isEquipmentRoundOverride(v) {
    return v === true || v === false;
  }

  /**
   * THE decision. `lineValue` is the price-book line / item-code `roundToHalfHour`
   * (true / false / unset); `companyDefault` is the company switch (boolean).
   */
  function resolveEquipmentRounding(lineValue, companyDefault) {
    if (lineValue === true) return true;
    if (lineValue === false) return false;
    return companyDefault === true;
  }

  /**
   * A dispatcher's jobDay rate pick (lineItemSelections) carries a SNAPSHOT of the
   * line's flag. Snapshots written before TASK-9489 stored `false` for an unset
   * line, so `false` alone cannot tell Never from Company default.
   *   - snapshot true                                   -> round (unchanged)
   *   - the picked line still exists and is Always/Never -> do not round (unchanged:
   *     a non-true snapshot never rounded)
   *   - the picked line is unset (Company default), or the snapshot itself is
   *     unset and the line is gone                      -> Company default
   *   - snapshot false and the line is gone             -> do not round
   * With the company switch off every branch returns exactly what the old
   * `selected.roundToHalfHour === true` did.
   */
  function resolveSelectionRounding(selectionValue, currentLine, companyDefault) {
    if (selectionValue === true) return true;
    if (currentLine && typeof currentLine === 'object') {
      if (isEquipmentRoundOverride(currentLine.roundToHalfHour)) return false;
      return companyDefault === true;
    }
    if (selectionValue === false) return false;
    return companyDefault === true;
  }

  /** UP to the next half hour; exact halves stay; <= 0 / non-finite -> 0. (TASK-1410) */
  function roundHalfHourUp(hours) {
    if (!Number.isFinite(hours) || hours <= 0) return 0;
    return Math.ceil((hours * 2) - 1e-9) / 2;
  }

  /**
   * Billable hours for one EQUIPMENT line: rounded when `round` is true, else the
   * raw window to 2 decimals. null / non-finite raw hours -> 0.
   */
  function equipmentBillHours(rawHours, round) {
    const h = Number(rawHours);
    if (rawHours === null || rawHours === undefined || !Number.isFinite(h)) return 0;
    if (round === true) return roundHalfHourUp(h);
    return Math.round(h * 100) / 100;
  }

  window.EquipmentRounding = Object.freeze({
    SETTING_KEY: EQUIPMENT_ROUND_SETTING_KEY,
    companyRoundsEquipment: companyRoundsEquipment,
    equipmentRoundChoice: equipmentRoundChoice,
    equipmentRoundStored: equipmentRoundStored,
    isEquipmentRoundOverride: isEquipmentRoundOverride,
    resolveEquipmentRounding: resolveEquipmentRounding,
    resolveSelectionRounding: resolveSelectionRounding,
    roundHalfHourUp: roundHalfHourUp,
    equipmentBillHours: equipmentBillHours
  });
})();
